// Shape types
export const TYPE_POLYGONS = 'polygon';
export const TYPE_LINES = 'line';

// Polygon variants
export const VARIANT_POLYGON_LPR = 'lpr';
export const VARIANT_POLYGON_PPE = 'ppe';

// Lines variants
export const VARIANT_LINES_PEOPLE_COUNTING = 'peopleCounting';
export const VARIANT_LINES_PPE = 'ppe';

// Yellow colour we use on drawing tool (copied from Google Earth)
export const YELLOW = '#fbc02e';

// Radius of node markers
export const POINT_RADIUS_MAJOR = 7;

// Larger invisible hit target used for selecting and dragging nodes
export const POINT_HIT_RADIUS_MAJOR = 18;

// Radius of marker shown halfway along shape edge for adding a new node
export const POINT_RADIUS_MINOR = 6;

// Treat lines as actually having this width to make them easier to click
// Line crossings only
export const CLICKABLE_LINE_WIDTH = 10;

// Constants representing save state
export const SAVE_STATE_SAVING = 'SAVING';
export const SAVE_STATE_SAVED = 'SAVED';
export const SAVE_STATE_FAILED = 'FAILED';
